/**
 * @fires netx:analytics:start
 */

import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';

export default function () {
	const promises = [];

	// TODO: we need a portal singleton that contains all these sorts of things
	var analyticOpts = null; // Netx.custom.portal ? Netx.custom.portal.analytics : null;
	// Check for analytics configuration:
	_.each(['google'], function (provider) {
		let trackingState, trackingCode;
		if (analyticOpts) {
			provider = analyticOpts[provider] || {};
			trackingState = provider.enabled;
			trackingCode = provider.trackingId;
		} else {
			trackingState = getPublicProperty(
				'analytics.' + provider + '.enabled',
				true,
			);
			trackingCode = getPublicProperty('analytics.' + provider + '.trackingId');
		}
		if (trackingState && trackingCode) {
			var d = new $.Deferred();
			promises.push(d);
			// Load & start Analytics.
			dispatcher.trigger(
				'netx:analytics:start',
				provider,
				trackingCode,
				function () {
					d.resolve();
				},
			);
		}
	});

	return Promise.all(promises);
}
